import React from 'react'
import bem from 'utils/bem';
import { NavLink } from 'react-router-dom';
import Text from 'components/Text';
import ruMenu from 'components/Menu/menu-ru';
import kzMenu from 'components/Menu/menu-kz';

const { block, el } = bem('footer-links');

const FooterLinks = () => {

    const menu = window.isRuDomain ? ruMenu : kzMenu;
    const links = [
        ...menu,
        {
            id: 'payment-rules',
            name: 'Правила сервиса',
            to: '/payment_rules'
        }
    ]

    const rLink = ({ name, to }, index) => {
        return <NavLink key={ index } className={ el('link') } to={ to }><Text>{ name }</Text></NavLink>
    }

    return (
        <div className={ block() }>
            { links.map(rLink) }
        </div>
    )
}

export default FooterLinks;
